<template>
    <v-app-bar
            id="app-bar"
            absolute
            app
            color="transparent"
            flat
            height="75"
    >
        <v-btn
                class="mr-3"
                elevation="1"
                fab
                small
                @click="setDrawer(!drawer)"
        >
            <v-icon v-if="value">
                mdi-view-quilt
            </v-icon>

            <v-icon v-else>
                mdi-dots-vertical
            </v-icon>
        </v-btn>

        <v-toolbar-title
                class="hidden-sm-and-down font-weight-light"
                v-text="$t($route.meta.title)"
        />

        <v-spacer/>

        <v-badge
                color="red"
                overlap
                bordered
                :value="unreadNotificationsCount > 0"
                v-if="isSeller"
        >
            <template v-slot:badge>
                <span>{{unreadNotificationsCount}}</span>
            </template>

            <v-icon color="primary">mdi-bell</v-icon>
        </v-badge>

        <v-btn
                class="ml-2 mr-2 mb-0"
                min-width="0"
                text
                :to="'/stores/' + userInformation.store_id"
                v-if="isSeller"
        >
            <v-icon>mdi-store</v-icon>
        </v-btn>


    </v-app-bar>
</template>

<script>
    // Components
    import {mapMutations, mapState, mapGetters} from "vuex";

    // Utilities
    export default {
        name: 'DashboardCoreAppBar',
        props: {
            value: {
                type: Boolean,
                default: false,
            },
        },
        data: () => ({}),
        mounted() {
            this.getUnreadNotifications();
            setTimeout(this.getUnreadNotifications, 1000 * 120)
        },
        computed: {
            ...mapState(['drawer', 'userInformation', 'unreadNotificationsCount']),
            ...mapGetters(['isSeller']),
        },
        methods: {
            ...mapMutations({
                setDrawer: 'SET_DRAWER',
            }),
            getUnreadNotifications() {
                this.$axios.get('notifications?exists[read_datetime]=false')
                    .then((response) => {
                        this.$store.commit('setUnreadNotificationsCount', response.data['hydra:totalItems']);
                    });
            }
        },
        components: {
        }
    }
</script>
